import { compareUnorderedArrays } from '../../../utils/arrayUtils';
import { countDays } from '../../../utils/dateFunctions';
import {
    getDateWithinMessage,
    getReqMessage
} from '../../../utils/formValidation/errorMessageFunctions';
import {
    validateServiceId,
    validateTeamId
} from '../../../utils/formValidation/validationFunctions';
import { validateAppointmentType } from '../validation/validationFunctions';

export const MAX_DATE_RANGE = 30;
export const NO_FILTER_CHANGE_MESSAGE = 'Filters have not been changed.';

export const validate = (filters, initialFilterState) => {
    let newErrors = {};

    newErrors = validateServiceId(filters.serviceId, newErrors);
    newErrors = validateTeamId(filters.teamId, newErrors);
    newErrors = validateAppointmentType(filters.typeIds[0], newErrors, 'typeIds');

    if (!filters.dateFrom || !filters.dateTo) {
        newErrors = {
            ...newErrors,
            dateRange: { error: true, message: getReqMessage('A date range') }
        };
    } else if (countDays(filters.dateFrom, filters.dateTo) > MAX_DATE_RANGE) {
        newErrors = {
            ...newErrors,
            dateRange: { error: true, message: getDateWithinMessage('End date', MAX_DATE_RANGE) }
        };
    }

    if (Object.keys(newErrors).length < 1) {
        if (compareUnorderedArrays(Object.values(filters), Object.values(initialFilterState))) {
            newErrors = {
                ...newErrors,
                button: { error: true, message: NO_FILTER_CHANGE_MESSAGE }
            };
        }
    }

    return newErrors;
};
